import apiClient from "../../../utils/clients/axios";

export const createKeyEntry = async (payload) => {
  const response = await apiClient.post("/keys/", payload);

  return response;
};

export const getKeysData = async () => {
  const { data } = await apiClient.get("/keys/queue/");

  return data;
};

export const updateKeyManagement = async (id) => {
  const response = await apiClient.patch(`/keys/returned?id=${id}`, {
    status: "returned",
  });

  return response;
};
